import type { NavigationGuardNext } from 'vue-router'

type LogoutContext = {
  next: NavigationGuardNext
}

const logout = ({ next }: LogoutContext): void => {
  localStorage.removeItem('token')
  localStorage.removeItem('withEndCustomers')
  sessionStorage.removeItem('currentCompanySlug')
  sessionStorage.removeItem('userRequestUrl')
  sessionStorage.removeItem('automations')
  sessionStorage.removeItem('validations')
  ;(window as any).$chatwoot?.reset()
  return next({ name: 'login' })
}

export default logout
